import * as React from 'react';

import { get } from 'js/lib/user';

import { ForcedSSORecoveryEmailModal } from 'bundles/enterprise-legacy-learner-home/components/modals/ForcedSSORecoveryEmailModal';
import {
  useOrgScopedRecoveryEmail,
  useOrgScopedUserEmails,
} from 'bundles/unified-common/contexts/org-scoped/EnterpriseOrgUserExperienceContext';
import useOrgScopedAlternativeEmailModal from 'bundles/unified-home-common/hooks/useOrgScopedAlternativeEmailModal';

/**
 * Org-scoped wrapper for ForcedSSORecoveryEmailModal.
 *
 * This component uses org-scoped contexts and hooks instead of program-scoped ones:
 * - Uses useOrgScopedUserEmails instead of useUserEmails from EnterpriseProgramContext
 * - Uses useOrgScopedRecoveryEmail instead of useRecoveryEmail from EnterpriseProgramContext
 * - Uses useOrgScopedAlternativeEmailModal instead of useAlternativeEmailModal
 *
 * The underlying ForcedSSORecoveryEmailModal component remains the same.
 */
const OrgScopedForcedSSORecoveryEmailModal = () => {
  const userId = get()?.id;
  const { userEmails = [], refetchUserEmails } = useOrgScopedUserEmails();
  const { recoveryEmail } = useOrgScopedRecoveryEmail();
  const { isOpen, onClose, shouldDeferOnClose } = useOrgScopedAlternativeEmailModal(userId, userEmails, recoveryEmail);

  const onUpdate = () => {
    refetchUserEmails?.();
  };

  return (
    <ForcedSSORecoveryEmailModal
      userId={userId}
      isOpen={isOpen}
      onClose={onClose}
      onUpdate={onUpdate}
      shouldDeferOnClose={shouldDeferOnClose}
      recoveryEmail={recoveryEmail}
    />
  );
};

export default OrgScopedForcedSSORecoveryEmailModal;
